import { BlockWrapper, defineBlock } from '@smartfire/js-block-engine';
import PracticeTimetableTile from '../../components/PracticeTimetableTile';
import { getRegisterLink } from '../../shared/tools';
import style from './block.module.scss';

const ListPractices = ({ practices, club }) => {
    const link = getRegisterLink(club);

    return practices?.length > 0 ? (
        <BlockWrapper.Div className={style.container}>
            <h2 className={style.title}>
                Découvrez nos <span>pratiques</span>
            </h2>
            <div className={style.practices}>
                {practices &&
                    practices.map((practice, i) => (
                        <PracticeTimetableTile key={i} link={link} {...practice} />
                    ))}
            </div>
        </BlockWrapper.Div>
    ) : (
        <BlockWrapper.Div />
    );
};

export default defineBlock({
    Block: ListPractices,
});
